import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  contentWrapper: {
    margin: '0 auto',
    maxWidth: ' 109.6rem',
    position: 'relative',
    marginBottom: '4rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
  },
  validationContentWrapper: {
    border: `0.2rem solid ${colors.red[600]}`,
  },
  icon: {
    marginBottom: '1.6rem',
  },
  headerCard: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
    marginBottom: '4rem',
  },
  headerWarning: {
    textAlign: 'center',
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
  },
  validationErrorTitle: {
    color: colors.red[600],
    textTransform: 'uppercase',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    letterSpacing: '0.1rem',
    paddingBottom: '1.6rem',
    margin: '0 0 1.6rem',
    fontSize: '1.6rem',
  },
  validationErrorsList: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
